// Marketing-Focused Content with Storytelling

export const trainerInfo = {
  name: "Vikas Vaid",
  title: "IFBB Pro Body Transformation Specialist",
  experience: "20+ Years",
  tagline: "Your Dream Body Is Closer Than You Think",
  heroSubtitle: "Stop Dreaming. Start Transforming.",
  description: "Remember that feeling when you avoided mirrors? When you felt invisible in a room? I've been there. Two decades ago, I made a choice that changed everything. Today, as an IFBB Pro, I've helped over 500 people rewrite their stories. Not just their bodies—their entire lives.",
  story: "I am an IFBB Pro Trainer, competitive bodybuilder, and one of the most experienced personal trainers in New York City, with over three decades of hands on expertise in body transformation and physique development. I trained under an IFBB Pro and have won multiple bodybuilding competitions, shaping my deep understanding of how elite bodies are built, refined, and sustained.\n\nCurrently, I train clients at Complete Body Gym on 19th Street in Manhattan, NYC, where I am known for delivering some of the best transformation results in the city. I am proud to be recognized as one of the best Indian personal trainers in NYC, trusted by clients who demand high standards, accountability, and visible progress.\n\nMy core expertise includes complete body transformation, beach body preparation, fat loss, muscle definition, and physique sculpting. Every program I design is customized, data driven, and aligned with your lifestyle, goals, and body type. I focus on intense yet intelligent training that maximizes results while minimizing wasted effort.\n\nAs a celebrity trainer and online fitness coach, I also work with clients worldwide through structured online training programs. These include personalized workout plans, tailored meal plans, weekly progress tracking, and consistent follow ups to ensure momentum and long term success.\n\nI believe transformation is not just physical. It is a mindset shift. My role is to push boundaries, unlock discipline, and help you achieve results you once thought were impossible. If you are searching for a professional personal trainer in Manhattan NYC who delivers proven results, elite coaching, and unmatched experience, I am here to guide you every step of the way.",
  stats: [
    { number: "500+", label: "Lives Transformed" },
    { number: "30+", label: "Years Mastering The Craft" },
    { number: "100%", label: "Commitment To Your Success" },
    { number: "IFBB", label: "Pro Certified" }
  ]
};

export const services = [
  {
    id: 1,
    title: "Build The Body That Commands Respect",
    subtitle: "Bodybuilding & Muscle Gain",
    description: "Tired of being the 'before' picture? Imagine walking into a room and feeling every eye on you—for all the right reasons. I'll show you the exact blueprint I used to go from average to IFBB Pro. No guesswork. No wasted years. Just pure, science-backed muscle growth.",
    icon: "Dumbbell",
    features: [
      "The '3-Phase Muscle Explosion' method that adds serious size",
      "Nutrition secrets that fuel growth without the bloat",
      "Progressive overload system that guarantees results",
      "Form mastery that prevents injury and maximizes gains"
    ],
    emotional: "Stop being invisible. Start being unforgettable."
  },
  {
    id: 2,
    title: "Finally Lose The Weight That's Holding You Back",
    subtitle: "Weight Loss & Fat Reduction",
    description: "You've tried everything. Every diet. Every workout fad. And you're still stuck. What if I told you it's not your fault? The real secret isn't about eating less—it's about eating smart and training strategically. I've cracked the code to sustainable fat loss that actually stays off.",
    icon: "TrendingDown",
    features: [
      "Custom meal plans that satisfy cravings while melting fat",
      "Metabolic reset protocols that rev up your fat-burning engine",
      "Weekly progress tracking with real-time adjustments",
      "Lifestyle coaching that makes transformation effortless"
    ],
    emotional: "This time will be different. This time, it's permanent."
  },
  {
    id: 3,
    title: "Train With A Pro From Anywhere In The World",
    subtitle: "Online Coaching Programs",
    description: "No gym nearby? Busy schedule? No problem. Get the same coaching that transformed 500+ bodies, delivered straight to your phone. I'll be your accountability partner, your motivator, and your guide—every single day. Distance won't stop your transformation.",
    icon: "Laptop",
    features: [
      "Daily video form checks that perfect your technique",
      "24/7 access to me via chat—questions answered within hours",
      "Weekly video calls to keep you on track and motivated",
      "Flexible programming that fits YOUR life"
    ],
    emotional: "Your excuses just ran out. Your transformation starts now."
  },
  {
    id: 4,
    title: "Dominate The Stage Like A Champion",
    subtitle: "Competition Prep (IFBB Pro Guidance)",
    description: "You've built the physique. Now it's time to showcase it. As an IFBB Pro, I know exactly what judges look for. I'll take you from 'good' to 'unforgettable' on stage. This is where champions are made.",
    icon: "Trophy",
    features: [
      "Peak week strategies that bring out every striation",
      "Posing mastery that tells your body's story",
      "Stage presence coaching that captivates judges",
      "Post-competition transition to maintain your physique"
    ],
    emotional: "Don't just compete. Dominate."
  }
];

export const transformations = [
  {
    id: 1,
    clientName: "John M., 34",
    achievement: "Lost 45 lbs in 6 Months",
    program: "Weight Loss Program",
    testimonial: "I was the guy who avoided family photos. My kids barely recognized me in old pictures. Vikas didn't just give me a meal plan—he gave me my life back. My wife says I'm a different person. She's right.",
    beforeStory: "Overweight, low energy, avoiding social events",
    afterStory: "Confident, energetic, living life fully",
    image: "https://images.unsplash.com/photo-1577221084712-45b0445d2b00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxib2R5YnVpbGRpbmd8ZW58MHx8fHwxNzY5NjQ2OTE5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 2,
    clientName: "Sarah K., 28",
    achievement: "Gained 15 lbs of Pure Muscle",
    program: "Muscle Gain Program",
    testimonial: "For years, I was 'the skinny girl.' I tried everything but couldn't gain weight. Vikas showed me I wasn't eating enough—or eating right. Six months later, I have curves, strength, and confidence I never thought possible.",
    beforeStory: "Underweight, weak, self-conscious",
    afterStory: "Strong, sculpted, unstoppable",
    image: "https://images.unsplash.com/photo-1603287681836-b174ce5074c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxib2R5YnVpbGRpbmd8ZW58MHx8fHwxNzY5NjQ2OTE5fDA&ixlib=rb-4.1.0&q=85"
  },
  {
    id: 3,
    clientName: "Mike R., 31",
    achievement: "1st Place Men's Physique Champion",
    program: "Competition Prep",
    testimonial: "I thought I knew training. Then I met Vikas. His competition prep is surgical—precise, strategic, effective. He didn't just prepare my body for the stage. He prepared my mind to win. First place felt inevitable.",
    beforeStory: "Good physique, no stage experience",
    afterStory: "Champion mindset and trophy to prove it",
    image: "https://images.pexels.com/photos/24809799/pexels-photo-24809799.jpeg"
  }
];

export const availableSlots = [
  { date: "2025-02-10", time: "10:00 AM" },
  { date: "2025-02-10", time: "2:00 PM" },
  { date: "2025-02-11", time: "9:00 AM" },
  { date: "2025-02-11", time: "4:00 PM" },
  { date: "2025-02-12", time: "11:00 AM" },
  { date: "2025-02-12", time: "3:00 PM" },
  { date: "2025-02-13", time: "10:00 AM" },
  { date: "2025-02-13", time: "1:00 PM" },
  { date: "2025-02-14", time: "9:00 AM" },
  { date: "2025-02-14", time: "5:00 PM" }
];

export const whyChooseMe = [
  {
    icon: "Flame",
    title: "30+ Years of Elite Experience",
    description: "Three decades of mastering body transformation. From training under IFBB Pros to becoming one myself. You're learning from someone who's lived every rep, every diet, every challenge.",
    stat: "30+ Years"
  },
  {
    icon: "Target",
    title: "Manhattan's Best Transformation Results",
    description: "Complete Body Gym, 19th Street NYC. Where the city's most serious transformations happen. Real results that turn heads on the streets of Manhattan.",
    stat: "Complete Body Gym"
  },
  {
    icon: "Zap",
    title: "Customized, Data-Driven Programs",
    description: "No cookie-cutter plans. Every workout, every meal is tailored to YOUR body type, lifestyle, and goals. Smart training that maximizes results, minimizes wasted time.",
    stat: "100% Custom"
  },
  {
    icon: "Trophy",
    title: "Competition-Winning Expertise",
    description: "Multiple bodybuilding championships. IFBB Pro guidance. I know what it takes to build a body that wins—on stage and in life.",
    stat: "IFBB Pro"
  },
  {
    icon: "Globe",
    title: "Train Anywhere: Gym or Online",
    description: "Manhattan local or halfway across the world—you get the same elite coaching. Weekly check-ins, personalized plans, and constant accountability.",
    stat: "Global Reach"
  },
  {
    icon: "Users",
    title: "Trusted by NYC's Best",
    description: "Celebrity clients. Business leaders. Athletes. When you demand the best, you come to me. Recognized as one of NYC's top Indian personal trainers.",
    stat: "Celebrity Trainer"
  }
];